import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';

export const functions_company = {

    data: function () {
        return {
            companies :[],
            company:null,
            companies_loaded:false,
        };
    },

    computed: {
    },

    methods: {
        /*
         *   Компания
         */

        loadCompany: function (company_id, onSuccess=null, param=null) {
            if (!this.isCompanyLoaded()) {
                this.httpPrepare();
                this.$http.get(this.apiurl('company/'+company_id)).then(function (response) {
                    response = this.httpSuccess(response);
                    this.company = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        resetCompany: function () {
            this.company = null;
            return this;
        },

        isCompanyLoaded: function () {
            return this.is(this.company);
        },

        saveCompany: function (images, onSuccess=null, param=null) {
            let formdata = new FormData();
            formdata.append('extra_boss_sign_file', images.boss_sign_file);
            formdata.append('extra_boss_sign_clean', images.boss_sign_clean);
            formdata.append('extra_bkkr_sign_file', images.bkkr_sign_file);
            formdata.append('extra_bkkr_sign_clean', images.bkkr_sign_clean);
            formdata.append('extra_stamp_file', images.stamp_file);
            formdata.append('extra_stamp_clean', images.stamp_clean);
            for ( var key in this.company ) { formdata.append(key, this.company[key]); }

            this.httpPrepare();
            this.$http.post(this.apiurl('company/'+this.company.id+'/save'), formdata, { headers: { 'Content-Type': 'multipart/form-data'} }).then(function (response) {
                response = this.httpSuccess(response);
                this.company = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        disableCompany: function (company_id, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('company/'+company_id+'/disable'), {}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        enableCompany: function (company_id, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('company/'+company_id+'/enable'), {}).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        createCompany: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('company/create')).then(function (response) {
                response = this.httpSuccess(response);
                this.company = response.payload;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
        },

        /*
         *   Список компаний
         */
        loadCompanies: function (onSuccess=null, param=null) {
            if (this.isCompaniesPreloaded()) { this.executeFunction(onSuccess, param); return this; }
            this.companies_loaded = false;
            this.companies = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('company')).then(function (response) {
                response = this.httpSuccess(response);
                this.companies = response.payload;
                this.$store.commit('savePreloadCompanies', this.companies);
                this.companies_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },


        loadCompaniesHotels: function (onSuccess=null, param=null) {
            if (this.isCompaniesHotelsPreloaded()) { this.executeFunction(onSuccess, param); return this; }
            this.companies_loaded = false;
            this.companies = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('company/hotels')).then(function (response) {
                response = this.httpSuccess(response);
                this.companies = response.payload;
                this.$store.commit('savePreloadCompaniesHotels', this.companies);
                this.companies_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        loadCompaniesAgencies: function (onSuccess=null, param=null) {
            if (this.isCompaniesAgenciesPreloaded()) { this.executeFunction(onSuccess, param); return this; }
            this.companies_loaded = false;
            this.companies = [];
            this.httpPrepare();
            this.$http.get(this.apiurl('company/agencies')).then(function (response) {
                response = this.httpSuccess(response);
                this.companies = response.payload;
                this.$store.commit('savePreloadCompaniesAgencies', this.companies);
                this.companies_loaded = true;
                this.executeFunction(onSuccess, param);
            }, this.httpError)
            return this;
        },

        // loadCompaniesAll: function () {
        //     if (!this.isCompaniesLoaded()) {
        //         this.companies_loaded = false;
        //         this.httpPrepare();
        //         this.$http.get(this.apiurl('company/all')).then(function (response) {
        //             response = this.httpSuccess(response);
        //             this.companies = response.payload;
        //             this.companies_loaded = true;
        //         }, this.httpError)
        //     }
        //     return this;
        // },

        isCompaniesPreloaded: function () {
            if (!this.is(this.$store.state.pl.companies)) { return false; }
            this.companies = this.$store.state.pl.companies;
            return true;
        },
        isCompaniesHotelsPreloaded: function () {
            if (!this.is(this.$store.state.pl.companiesHotels)) { return false; }
            this.companies = this.$store.state.pl.companiesHotels;
            return true;
        },
        isCompaniesAgenciesPreloaded: function () {
            if (!this.is(this.$store.state.pl.companiesAgencies)) { return false; }
            this.companies = this.$store.state.pl.companiesAgencies;
            return true;
        },

        resetCompanies: function () {
            this.companies = [];
            return this;
        },

        isCompaniesLoaded: function () {
            return (this.companies !== null) && this.companies.length && this.companies_loaded;
        },

    },
};

